import type { PartnerTradeStatus } from '@/entities/business-relationship/api/business-relationship.api';
import {
  PharmaCompanyFilterGroup,
  UserFilterGroup,
} from '@/entities/filter/ui/FilterSelects';
import { FilterDrawer, FilterGroup } from '@/shared/ui';

export interface ClientsFilter {
  userIds?: number[];
  pharmaCompanyIds?: number[];
  /** 없으면 전체(거래 중 + 거래 종료) */
  tradeStatus?: PartnerTradeStatus;
}

/** 드로어 초안 — 목록은 []가 '아무것도 안 고름'일 수 있다 */
interface ClientsFilterDraft {
  userIds?: number[];
  pharmaCompanyIds?: number[];
  tradeStatus?: string[];
}

const TRADE_STATUS_OPTIONS = [
  { value: 'TRADING', label: '거래 중' },
  { value: 'ENDED', label: '거래 종료' },
];

/** 체크 상태 → URL 값. 하나만 고르면 그 값, 둘 다·없음은 전체(생략) */
const fromTradeStatusChecks = (
  checks: string[] | undefined,
): PartnerTradeStatus | undefined => {
  if (checks?.length !== 1) return undefined;
  return checks[0] === 'ENDED' ? 'ENDED' : 'TRADING';
};

/** 아무것도 안 고른 목록([])은 전체로 본다 */
const toListFilter = <T,>(values: T[] | undefined) =>
  values && values.length > 0 ? values : undefined;

interface ClientsFilterDrawerProps {
  open: boolean;
  value: ClientsFilter;
  onClose: () => void;
  onApply: (filter: ClientsFilter) => void;
}

/** 06 거래처 정보 필터 — 담당자 · 제약사 · 거래 상태 (모두 다중 선택, 기본 전체) */
export function ClientsFilterDrawer({
  open,
  value,
  onClose,
  onApply,
}: ClientsFilterDrawerProps) {
  const draftValue: ClientsFilterDraft = {
    userIds: value.userIds,
    pharmaCompanyIds: value.pharmaCompanyIds,
    tradeStatus: value.tradeStatus ? [value.tradeStatus] : undefined,
  };

  return (
    <FilterDrawer
      open={open}
      value={draftValue}
      onClose={onClose}
      onApply={(draft) =>
        onApply({
          userIds: toListFilter(draft.userIds),
          pharmaCompanyIds: toListFilter(draft.pharmaCompanyIds),
          tradeStatus: fromTradeStatusChecks(draft.tradeStatus),
        })
      }
    >
      {(draft, patch) => (
        <>
          <UserFilterGroup
            value={draft.userIds}
            onChange={(userIds) => patch({ userIds })}
          />
          <PharmaCompanyFilterGroup
            value={draft.pharmaCompanyIds}
            onChange={(pharmaCompanyIds) => patch({ pharmaCompanyIds })}
          />
          <FilterGroup
            title="거래 상태"
            value={draft.tradeStatus}
            options={TRADE_STATUS_OPTIONS}
            onChange={(tradeStatus) => patch({ tradeStatus })}
          />
        </>
      )}
    </FilterDrawer>
  );
}
